import { captureMessage } from '@sentry/react';

// should be used for any user-supplied value
export function safelyUpdateLocation(path: string, replace = false) {
  try {
    const url = new URL(path);
    if (url.protocol !== 'https:' && url.origin !== window.location.origin) {
      return;
    }

    // TODO: use an allow list of valid redirection targets as well
    captureMessage(`Safely redirecting user to: ${url.origin}`, 'debug');

    if (replace) {
      window.location.replace(url);
    } else {
      window.location.href = url.toString();
    }
  } catch (_err) {
    return;
  }
}

export function isUrlValidElseRaiseError(path: string) {
  const url = new URL(path);
  let isValid: boolean = true;
  if (url.protocol !== 'https:' && url.origin !== window.location.origin) {
    isValid = false;
  }
  if (!isValid) {
    throw new Error('URL ' + path + 'is not secure');
  }
  return true;
}

export const ALLOWED_EXTERNAL_ORIGINS = [
  'https://api.gusto.com',
  'https://api.gusto-demo.com',
  'https://employ.remote.com',
  'https://remote.com',
];

export const isUrlInternal = (url: URL) => {
  return url.origin === window.location.origin;
};

export const isExternalUrlAllowed = (url: URL) => {
  const isInternal = isUrlInternal(url);
  const isSandbox = window.location.host === 'sandbox-app.mosey.com';

  if (
    !isSandbox &&
    !isInternal &&
    !ALLOWED_EXTERNAL_ORIGINS.includes(url.origin)
  ) {
    return false;
  }

  return true;
};

export const decodeBase64UrlOrOriginalUrl = (original_url: string) => {
  try {
    let url: string = original_url;
    const padLength = 4 - (url.length % 4);
    if (padLength !== 4) {
      url += '='.repeat(padLength);
    }

    // Convert base64url to base64
    const encoded = url.replace(/-/g, '+').replace(/_/g, '/');

    // Decode
    return decodeURIComponent(
      Array.prototype.map
        .call(
          atob(encoded),
          (c) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2),
        )
        .join(''),
    );
  } catch {
    // Any exception, return the original_url as-is.
    return original_url;
  }
};
